import React from 'react';
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';

const drawerWidth = 270;

/**
 * Custom styling for the sidebar using material ui
 **/

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(46px)`,
});

export const PermanentDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  bottom: 0,
  boxSizing: 'border-box',
  borderRight: '1px solid #ffffff20',

  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
  ['& .MuiDrawer-paper']: {
    marginTop: 115,
    backgroundColor: '#0A0A0A',
    boxSizing: 'border-box',
    color: '#fff',
    zIndex: 0,
    left: 'auto',
  },
}));

export const PermanentDrawerList = styled(List)(({ open }) => ({
  display: !open ? 'none' : 'block',
  marginBottom: 'auto',
}));

export const MobileDrawer = styled(Drawer)({
  display: { xs: 'block', md: 'none' },
  zIndex: '99999999',
  ['& .MuiDrawer-paper']: {
    boxSizing: 'border-box',
    width: '100%',
    background: '#fff',
  },
});

export const StyledListItemButton = styled(ListItemButton)({
  backgroundColor: 'transparent',
  color: 'white',

  '&.Mui-selected': {
    backgroundColor: 'transparent',
    '.MuiListItemText-primary': {
      color: '#fecb04',
    },
  },
});

export const StyledListItemText = styled(ListItemText)({
  textTransform: 'uppercase',
});

export const listItemTypography = {
  fontWeight: 600,
  fontSize: 20,
  lineHeight: '25px',
  letterSpacing: '0.02em',
};

export const listItemTypographyMobile = {
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '185%',
  textTransform: 'uppercase',
  color: '#0A0A0A',
};

export const CollapseListItem = styled(ListItemButton)({
  paddingTop: 0,
  paddingBottom: 0,
  '&.Mui-selected': {
    backgroundColor: 'transparent !important',
    '.MuiListItemText-primary': {
      color: '#fecb04',
    },
  },
});

export const CollapseListItemMobile = styled(CollapseListItem)({
  padding: '8px',
  textAlign: 'center',
  borderBottom: '1px solid #EFEFEF',
});

export const CollapseListItemText = styled(ListItemText)({
  color: '#C4C4C4',
  textTransform: 'uppercase',
  opacity: 0.8,
});

export const CollapseListItemTextMobile = styled(CollapseListItemText)({
  color: '#0A0A0A',
  opacity: 1,
  fontSize: '16px',
  lineHeight: '185%',
});

export const collapseListItemTypography = {
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '29px',
};

export const StyledButton = styled(Button)({
  backgroundColor: '#151515',
  color: '#FFFFFF',
  opacity: 0.8,

  fontSize: '16px',
  lineHeight: '178%',
  letterSpacing: '0.02em',
  textTransform: 'uppercase',
});

export const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  color: !expand ? '#ffffff' : '#fecb04',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

/**
 * End of styling for the sidebar using material ui
 **/
